export enum CheckStatus {
	QUEUED = 0,
	SENT = 1,
	ERROR = 2,
	CANCELLED = 3,
	COMPLETE = 4,
	INPROCESS = 5,
}
